/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Link",
  size: 20
}

const SvgLink = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path
      fill="none"
      strokeWidth={1.1}
      d="M10.625 12.375l-3.1 3.1c-.7.7-1.6.7-2.3 0l-.7-.7c-.7-.701-.7-1.6 0-2.3l3.1-3.1M9.325 7.375l3.1-3.1c.7-.7 1.6-.7 2.299 0l.701.7c.7.7.7 1.6 0 2.3l-3.1 3.1M7.925 11.875l4-3.9"
    />
  </Svg>
)

SvgLink.defaultProps = defaultProps
export default SvgLink
